var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-PC_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PC_",
    "data-name": "PC ",
    clipPath: "url(#clip-PC_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc",
    d: "M29.65,117.89V423.565H160.443V117.89Zm95.036,280.156c-6.376,0-11.545-5.45-11.545-12.173s5.169-12.173,11.545-12.173,11.545,5.45,11.545,12.173-5.169,12.173-11.545,12.173Zm18.892-209.331H46.348V171.008h97.219v17.706Zm0-35.412H46.348V135.6h97.219V153.3ZM304.156,361.914h76.721v43.944h43.808v17.706H260.37V405.859h43.808V361.914ZM180.311,117.89V344.208H504.775V117.89H180.3ZM487.982,326.5H197.093V135.6H487.982Z",
    transform: "translate(-11.213 -14.727)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/PC.06239c233142663de2847704c2f7a59e.svg";
export { ForwardRef as ReactComponent };